enum CommunicationKey {
  // MEMBERSHIP
  EMAIL_SUBSCRIPTION_REJECTED = 'email_subscription_rejected',
  NOTIFICATION_MEMBERSHIP_NOSHOW = 'notification_membership_noshow',
  NOTIFICATION_MEMBERSHIP_CONFIRMATION = 'notification_membership_confirmation',
  NOTIFICATION_MEMBERSHIP_BIRTHDAY = 'notification_membership_birthday',
  EMAIL_SUBSCRIPTION_ACCEPTED = 'email_subscription_accepted',
  EMAIL_SUBSCRIPTION_FAILED_TO_RENEW = 'email_subscription_failed_to_renew',
  EMAIL_SUBSCRIPTION_PAYMENT_FAILED = 'email_subscription_payment_failed',
  EMAIL_SUBSCRIPTION_REQUEST_RECEIVED = 'email_subscription_request_received',

  // BUSINESS
  EMAIL_COMPANY_CONTACT_INVITATION_CONFIRMATION_ADD = 'email_company_contact_invitation_confirmation_add',
  EMAIL_BUSINESS_PROFILE_CODE = 'email_business_profile_code',
  EMAIL_COMPANY_CONTACT_INVITATION_ADDED = 'email_company_contact_invitation_added',

  // RESERVATION
  EMAIL_RESERVATION_CANCELLED = 'email_reservation_cancelled',
  EMAIL_RESERVATION_PLACED = 'email_reservation_placed',
  EMAIL_RESERVATION_UPDATED = 'email_reservation_updated',
  NOTIFICATION_RESERVATION_CONFIRMATION = 'notification_reservation_confirmation',
  NOTIFICATION_RESERVATION_NOSHOW = 'notification_reservation_noshow',

  // USER
  EMAIL_ACCOUNT_RETENTION_WARNING = 'email_account_retention_warning',

  // NOTIFICATIONS
  NOTIFICATION_PUSH_CAMPAIGN = 'notification_push_campaign',
}

export { CommunicationKey }
